import { Skeleton, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { Table } from '../../patient-profile-page.styles';

const TreatmentPlanTableSkeleton = () => (
  <Table>
    <TableHead>
      <TableRow>
        <TableCell style={{ width: '15%' }}>Date</TableCell>
        <TableCell>Description</TableCell>
        <TableCell>Status</TableCell>
        <TableCell style={{ width: '20%' }}>Followup</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {[...Array(5)].map((_, index) => (
        <TableRow key={index}>
          <TableCell style={{ width: '15%' }}>
            <Skeleton variant="text" width={80} height={20} />
          </TableCell>
          <TableCell>
            <Skeleton variant="text" width="80%" height={20} />
          </TableCell>
          <TableCell>
            <Skeleton variant="text" width={100} height={20} />
          </TableCell>
          <TableCell style={{ width: '20%' }}>
            <Skeleton variant="text" width={100} height={20} />
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export default TreatmentPlanTableSkeleton;
